const INIT_STATE = {
	stack: [],
	update: new Date().getTime(),
	tabIndex: 0,
	title: '',
	titleStack: [],
	url: '',
	priceRial: '',
	canBePayed: '',
	packsCount: '',
	cartIds: '',
	// cashBack:{}
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {
		case 'pushForm':
			state.stack.push(action.payload.form);
			state.titleStack.push(action.payload.title);
			state.title = action.payload.title;
			state.url = action.payload.url;
			state.update = new Date().getTime();

			document.body.setAttribute('frm', action.payload.url);
			window.history.pushState({ component: action.payload.url }, action.payload.title)
			return { ...state };
		case 'setTitle':
			state.titleStack = [action.payload.title];
			return { ...state };
		case 'updateIndexTab':
			state.tabIndex = action.payload.index;

			return { ...state };
		case 'popStack':
			state.stack.pop();
			state.titleStack.pop();

			state.update = new Date().getTime();

			return { ...state };
		case 'popToRoot':
			window.history.go((window.history.length - 1) * -1);
			state.stack.splice(0);
			state.titleStack.splice(0);
			state.update = new Date().getTime();

			return { ...state };

		case 'popToForm':
			window.history.go((window.history.length - action.payload.index - 1) * -1);
			state.stack.splice(action.payload.index);
			state.titleStack.splice(action.payload.index);
			state.update = new Date().getTime();
			return { ...state };

		case 'pop':
			window.history.back();

			return { ...state };
		case 'clearStack':

			window.history.go((window.history.length - 1) * -1);
			state.stack = [];
			state.titleStack = [];
			state.update = new Date().getTime();

			return { ...state };
		case 'getStack':
			return state.stack;
		case 'overallPayment':
			state.priceRial = action.priceRial;
			state.canBePayed = action.canBePayed;
			state.packsCount = action.packsCount;
			state.cartIds = action.cartIds;

			return { ...state }

		default:
			return { ...state };
	}
};
